import React, { useState, useEffect, useContext } from "react";
import {
  Modal,
  Box,
  IconButton,
  Typography,
  CardMedia,
  Card,
  Button
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import urlconfig from "../config/urlconfig";
import { ItemsContext } from "../App";
import { formatCurrency } from "../util";
import { useAuth } from "../AuthProvider";
import { usePermissions } from "../rbac/PermissionsProvider";
import { PERMISSIONS } from "../rbac/permissions";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "85%",
  maxWidth: "1000px",
  height: "85%",
  bgcolor: "background.paper",
  // boxShadow: 24,
  backdropFilter: "blur(8px)",
  boxShadow: "0 8px 10px rgba(0,0,0,0.1)",
  
  borderRadius: "16px",
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
};

const scrollContent = {
  flex: 1,
  overflowY: "auto",
  paddingRight: "8px",
  paddingBottom: "100px",
};

export default function SalesInovoiceModal({ open, onClose, item, getApiToken }) {
  const [files, setFiles] = useState([]);
  const { items } = useContext(ItemsContext);
  const { username } = useAuth();

  const { can } = usePermissions();
  const DeleteAccess = can(PERMISSIONS.INVOICE_DELETE);

  useEffect(() => {
    if (!open || !item) return;

    const fetchFiles = async () => {
      try {
        const token = await getApiToken();

        const response = await fetch(
          `${urlconfig.backend_api_base_url}/api/v2/bill/${item.id}/view-sale-invoice?soNumber=${item.salesOrderNo}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        const data = await response.json();
        setFiles(data.files || []);
      } catch (err) {
        alert("Failed to load bills: " + err.message);
      }
    };

    fetchFiles();
  }, [open, item]);

  // customrow calculations
  const getCustomTotal = (rows, key) =>
  rows?.reduce((sum, r) => sum + (parseFloat(r[key]) || 0), 0) || 0;

  // Helper to render PDF or Image
  const renderFile = (url) => {
    if (!url) return <Typography variant="subtitle2" color="error" >File not found or it may have been deleted</Typography>;
    const isPDF = url.toLowerCase().includes(".pdf");

    return isPDF ? (
      <iframe
        src={url}
        style={{
          width: "100%",
          height: "300px",
          borderRadius: "12px",
          border: "1px solid #ddd",
        }}
      />
    ) : (
      <CardMedia
        component="img"
        src={url}
        sx={{
          width: "100%",
          borderRadius: "12px",
          border: "1px solid #ddd",
          maxHeight: "200px",
          objectFit: "contain",
        }}
      />
    );
  };

  // Combine main item + API files into a single array of rows
  const combinedRows = [];

  // If main item exists, add it first
  if (item?.salesOrderFileUrl || item?.salesInvoiceFileUrl) {
    combinedRows.push({
      salesInvoiceNumber: item?.salesInvoiceNumber || "-",
      salesOrderFileUrl: item?.salesOrderFileUrl,
      salesInvoiceFileUrl: item?.salesInvoiceFileUrl,
      salesInvoiceAmount: item?.salesInvoiceAmount,
      uploadedAt: item?.billUploadedAt,
    });
  }

  // Add API files
  files.forEach((f) => {
    combinedRows.push({
      id:f.id,
      salesInvoiceNumber: f?.salesInvoiceNumber || "-",
      salesOrderFileUrl: f?.salesOrderFileUrl,
      salesInvoiceFileUrl: f?.salesInvoiceFileUrl,
      salesInvoiceAmount: f?.salesInvoiceAmount,
      uploadedAt: f?.uploadedAt,
    });
  });

      const actualInvoiceAmount = item ? (() => {
      const tSp  = Number(item.transportationTotalSp || 0);
      const cSp  = Number(item.customizationTotalSp  || 0);
      const mSp  = Number(item.marketingTotalSp       || 0);
      const tGst = Number(item.costSummary?.transportationGST || 0);
      const cGst = Number(item.costSummary?.customizationGST  || 0);
      const mGst = Number(item.costSummary?.marketingGST      || 0);
      const itemSpTotal = item.items?.reduce((sum, i) => {
        const sp = Number(i.sp || 0), gst = Number(i.gst || 0), qty = Number(i.qty || 0);
        return sum + (sp + (sp * gst) / 100) * qty;
      }, 0) || 0;
      const customSpWithGst = (item.customRows || []).reduce((s, r) => {
        const sp = parseFloat(r.customTotalSp) || 0, gst = parseFloat(r.customGST) || 0;
        return s + sp * (1 + gst / 100);
      }, 0);
      return itemSpTotal + tSp * (1 + tGst / 100) + cSp * (1 + cGst / 100) + mSp * (1 + mGst / 100) + customSpWithGst;
    })() : 0;
    const totalInvoiceAmount = combinedRows.reduce(
      (sum, row) => sum + Number(row.salesInvoiceAmount || 0),
      0
    );
    
    const sortedRows = [...combinedRows].sort(
      (a, b) => new Date(b.uploadedAt) - new Date(a.uploadedAt)
    );

    const formatIST = (dateStr) => {
    if (!dateStr) return "No Date";
    return new Date(dateStr).toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      dateStyle: "medium",
      timeStyle: "short",
    });
  };

   const handleDeleteSalesInvoice = async (invoiceId) => {
    const token = await getApiToken();

    await fetch(
      `${urlconfig.backend_api_base_url}/api/v2/bill/delete-sale-invoice?invoiceId=${invoiceId}`,
      {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    setFiles(prev =>
      prev.filter(f => f.salesInvoiceFileUrl || f.salesOrderFileUrl)
    );
  };

  const handleDeleteSalesOrder = async (invoiceId) => {
    const token = await getApiToken();

    await fetch(
      `${urlconfig.backend_api_base_url}/api/v2/bill/delete-sale-order?invoiceId=${invoiceId}`,
      {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    setFiles(prev =>
      prev.filter(f => f.salesInvoiceFileUrl || f.salesOrderFileUrl)
    );
    onClose();
  };   

  const handleConfirmDelete=(type, id)=>{
    if (!window.confirm("Are you sure you want to delete this item?")) return;
      if (type === "SO") {
        handleDeleteSalesOrder(id);
      }

      if (type === "SI") {
        handleDeleteSalesInvoice(id);
      }
  }


  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle} p={2}>

        {/* Close Button */}
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            top: 10,
            right: 10,
            bgcolor: "rgba(255,255,255,0.7)",
            backdropFilter: "blur(4px)",
          }}
        >
          <CloseIcon />
        </IconButton>

        <Typography variant="h6" mb={2} fontWeight="600">
          View SO & SI
        </Typography>

          
        {/* Scrollable content */}
        <Box sx={scrollContent}>
          {sortedRows.map((row, idx) => (
            <Box
              key={idx}
              sx={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 2,
                mb: 4,
                border: "1px solid #eee",
                borderRadius: "12px",
                p: 2,
                boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
              }}
            >
               <Typography variant="caption" fontWeight={600}>
        #{idx + 1}
      </Typography>

      <Typography variant="caption" color="text.secondary">
        Uploaded: {formatIST(row.uploadedAt) || "N/A"}
      </Typography>
              <Box>
                <Typography variant="subtitle1" fontWeight={700}>
                  Sales Order
                </Typography>
                <Typography variant="body2">
                  Sales Order No: {item.salesOrderNo}
                </Typography>
                {renderFile(row.salesOrderFileUrl)}
                {/**Delete SO Button */}
                {row.salesOrderFileUrl &&  DeleteAccess &&(
                  <Button
                    variant="contained"
                    color="error"
                    size="small"
                    // onClick={() => handleDeleteSalesOrder(row.id)}
                    onClick={() => handleConfirmDelete("SO", row.id)}
                  >
                    Delete SO
                  </Button>
                  
                )}
              </Box>

              <Box>
                <Typography variant="subtitle1" fontWeight={700}>
                  Sales Invoice
                </Typography>
                <Typography variant="body2">
                  Sales Invoice No: {row.salesInvoiceNumber}  
                  &nbsp; | Value: {formatCurrency(row.salesInvoiceAmount)}
                </Typography>
                {renderFile(row.salesInvoiceFileUrl)}
                {/**Delete SI Button */}
                {row.salesInvoiceFileUrl && DeleteAccess &&(
                    <Button
                      variant="contained"
                      color="error"
                      size="small"
                      // onClick={() => handleDeleteSalesInvoice(row.id)}
                      onClick={() => handleConfirmDelete("SI", row.id)}
                    >
                      Delete SI
                    </Button>
                  )}
              </Box>
            </Box>
          ))}
        </Box>

        {/* FIXED SUMMARY CARD */}
        <Card
          sx={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            p: 2,
            display: "flex",
            justifyContent: "space-between",
            background: "white",
            // boxShadow: "0 -4px 16px rgba(0,0,0,0.1)",
            borderTop: "1px solid #eee",
          }}
        >
          <Typography fontWeight="bold" fontSize="18px">
            SO Value: ₹{formatCurrency(actualInvoiceAmount)}
          </Typography>

          <Typography fontWeight="bold" fontSize="18px">
            SI Value: ₹{formatCurrency(totalInvoiceAmount)}
          </Typography>

          <Typography
            fontWeight="bold"
            fontSize="18px"
            sx={{ color: actualInvoiceAmount - totalInvoiceAmount < 0 ? "red" : "green" }}
          >
            Balance: ₹{formatCurrency(actualInvoiceAmount - totalInvoiceAmount)}
          </Typography>
        </Card>
      </Box>
    </Modal>
  );
}
